import type { PointerEvent } from 'react';
import { MARK_PATH, MARK_VIEWBOX } from '@/components/ui/logoPath';

/** Depth built from the actual brand path; no WebGL or additional download. */
export function FalconSculpture() {
  function move(event: PointerEvent<HTMLDivElement>) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)').matches) return;
    const box = event.currentTarget.getBoundingClientRect();
    event.currentTarget.style.setProperty('--turn-x', `${((event.clientY - box.top) / box.height - 0.5) * -12}deg`);
    event.currentTarget.style.setProperty('--turn-y', `${((event.clientX - box.left) / box.width - 0.5) * 16}deg`);
  }
  return (
    <div className="falcon-sculpture" aria-hidden="true" onPointerMove={move} onPointerLeave={(event) => {
      event.currentTarget.style.setProperty('--turn-x', '0deg');
      event.currentTarget.style.setProperty('--turn-y', '0deg');
    }}>
      <div className="sculpture-orbit sculpture-orbit-one" />
      <div className="sculpture-orbit sculpture-orbit-two" />
      <div className="sculpture-mark">
        {[0, 1, 2, 3].map((layer) => (
          <svg key={layer} viewBox={MARK_VIEWBOX} focusable="false" style={{ transform: `translateZ(${layer * 8}px) translate(${layer * -3}px, ${layer * -3}px)` }}>
            <path d={MARK_PATH} />
          </svg>
        ))}
      </div>
      <span className="sculpture-caption">Vision. Precision. Speed.</span>
    </div>
  );
}
